module.exports = __webpack_public_path__ + "static/img/voice4.c7f916cb.png";